/**
 * The Staff Site path to a details payload's event, shared by the details
 * modals (PRO-1514). The shared column helper wants the event's LOCAL start
 * date, which these payloads carry only as a UTC instant plus a zone.
 */

import * as moment from 'moment-timezone';

import { getBookingEventDetailsLink } from '../../../../../models/report-columns/bookings';

export function getDetailsEventLink(details: {
  event_first_part_id: number | null,
  event_start_datetime: string | null,
  event_end_datetime: string | null,
  time_zone: string,
} | null): string | null {
  if (!details) {
    return null;
  }

  return getBookingEventDetailsLink({
    event_first_part_id: details.event_first_part_id,
    event_start_datetime: details.event_start_datetime,
    event_end_datetime: details.event_end_datetime,
    event_start_date: details.event_start_datetime
      ? moment(details.event_start_datetime).tz(details.time_zone).format('YYYY-MM-DD')
      : null,
  });
}
